export default __webpack_public_path__ + "static/media/home-planet.png?.36d29fbf";